import { CreateDriverCertificates, CreateDriverRequestBody } from "../apis";
import { DriverFormValues } from "../components";
import { DriverCertificateType } from "../constants";

export const convertFormDataToCreateRequestBody = (
  formData: DriverFormValues
): CreateDriverRequestBody => {
  const certificates: CreateDriverCertificates = [
    {
      type: DriverCertificateType.DriverLicense,
      reference: formData.driverLicense.reference,
      imagesIds: formData.driverLicense.images.map((image) => image.id)
    },
    {
      type: DriverCertificateType.Insurance,
      reference: formData.insurance.reference,
      imagesIds: formData.insurance.images.map((image) => image.id)
    },
    {
      type: DriverCertificateType.Id,
      reference: formData.idLicense.reference,
      imagesIds: formData.idLicense.images.map((image) => image.id)
    },
    {
      type: DriverCertificateType.Vehicle,
      reference: formData.vehicle.reference,
      imagesIds: formData.vehicle.images.map((image) => image.id)
    }
  ];

  return {
    phoneNumber: formData.phoneNumber.replace(/\s/g, ""),
    firstname: formData.firstname,
    lastname: formData.lastname,
    address: formData.address,
    birthdate: formData.birthdate ? formData.birthdate.toISOString() : null,
    imageId: formData.image?.id ?? undefined,
    password: formData.password,
    repeatPassword: formData.repeatPassword,
    certificates,
    priority: formData.priority,
    capacity: formData.capacity,
    totalCargoVolume: formData.totalCargoVolume,
    totalCargoWeight: formData.totalCargoWeight,
    deliveryZonesIds: formData.deliveryZones.map((zone) => zone.value),
    deliveryCompanyId: formData.deliveryCompanyId || undefined
  };
};
